










 

 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NewTeamOrgPicker_organizations",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewTeamOrgDropdown_organizations"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingTier",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "eb8b52e2019a37184bac88c1dae49b99";

export default node;
